import {ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'list-views-detail-back',
  templateUrl: './list-views-detail-back.component.html',
  styleUrls: ['./list-views-detail-back.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListViewsDetailBackComponent {
  @Output() back = new EventEmitter();
}
